import { fromMonetaryToInt, sumMonetaryValues } from "@common/helpers/monetary";
import { InvoiceSource } from "@common/types/invoice";
import { useInvoiceImportedSettlements } from "@api/invoice.api";
import { QuickBooksSettlementExtent } from "./getInvoiceStatusTransitionDisabledReason";

interface UseQuickBooksSettlementExtentParams {
    id: string;
    source: InvoiceSource;
    total: number;
}

export function useQuickBooksSettlementExtent(
    invoice: UseQuickBooksSettlementExtentParams,
): QuickBooksSettlementExtent {
    const settlementsQuery = useInvoiceImportedSettlements({
        invoiceId: invoice.id,
        source: invoice.source,
    });
    const settlements = settlementsQuery.data ?? [];
    if (settlements.length === 0) {
        return QuickBooksSettlementExtent.NONE;
    }
    const settledCents = fromMonetaryToInt(
        sumMonetaryValues(settlements.map((settlement) => settlement.amount)),
    );
    return settledCents >= fromMonetaryToInt(invoice.total)
        ? QuickBooksSettlementExtent.FULL
        : QuickBooksSettlementExtent.PARTIAL;
}
